import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Button, MenuButton } from '@applyboard/crystal-ui';
import { MoreVertOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker } from '@applyboard/ui-utils';
import { getChartFileName, useChart } from "../charts/utils/global";
var imageFormat = /*#__PURE__*/function (imageFormat) {
  imageFormat["image/png"] = "PNG";
  imageFormat["image/jpeg"] = "JPEG";
  imageFormat["image/svg+xml"] = "SVG";
  imageFormat["application/pdf"] = "PDF";
  return imageFormat;
}(imageFormat || {});
export function ChartExportMenu(_ref) {
  var chartTitle = _ref.chartTitle,
    chartSubtitle = _ref.chartSubtitle,
    _ref$chartAppliedFilt = _ref.chartAppliedFilters,
    chartAppliedFilters = _ref$chartAppliedFilt === void 0 ? [] : _ref$chartAppliedFilt;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var chartRef = useChart();
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var chartExportTrack = function chartExportTrack(format) {
    trackEvent({
      event: 'Agent Dashboard - Performed Action On Report',
      data: {
        performedAction: "Download chart in ".concat(format, " format"),
        reportName: chartTitle
      }
    });
  };
  function exportAsCsv() {
    var _chartRef$current;
    var csvTitle = chartTitle;
    if (chartSubtitle) csvTitle = "\"".concat(chartTitle, " - ").concat(chartSubtitle, "\"");
    var csvFilters = chartAppliedFilters === null || chartAppliedFilters === void 0 ? void 0 : chartAppliedFilters.map(function (item) {
      return "\"".concat(item.label, ": ").concat(item.value, "\"");
    });
    var csvContent = [csvTitle, csvFilters.join('\n'), 'Chart data:', chartRef === null || chartRef === void 0 || (_chartRef$current = chartRef.current) === null || _chartRef$current === void 0 ? void 0 : _chartRef$current.chart.getCSV()];

    // Creates a blob and an object URL
    var csvBlob = new Blob([csvContent.join('\n')], {
      type: 'text/csv'
    });
    var csvHref = window.URL.createObjectURL(csvBlob);

    // Puts it on a element and triggers a click to actually download the file
    var a = document.createElement('a');
    a.href = csvHref;
    a.download = getChartFileName(chartTitle, chartSubtitle) + '.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    chartExportTrack('CSV');
  }
  function exportAsImage(imageType) {
    var _chartRef$current2;
    (_chartRef$current2 = chartRef.current) === null || _chartRef$current2 === void 0 || _chartRef$current2.chart.exportChart({
      type: imageType
    }, {});
    chartExportTrack(imageFormat[imageType]);
  }
  return /*#__PURE__*/React.createElement(MenuButton, {
    alignment: "right",
    onOpenChange: setIsOpen,
    open: isOpen
  }, /*#__PURE__*/React.createElement(MenuButton.Trigger, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setIsOpen(true);
    },
    leadIcon: MoreVertOutlineIcon,
    "aria-label": "Export Menu Button",
    variant: "highlighted"
  })), /*#__PURE__*/React.createElement(MenuButton.Button, {
    id: "exportToCsv",
    onClick: exportAsCsv
  }, "Export CSV Data"), /*#__PURE__*/React.createElement(MenuButton.Button, {
    id: "exportToPng",
    onClick: function onClick() {
      return exportAsImage('image/png');
    }
  }, "Download PNG image"), /*#__PURE__*/React.createElement(MenuButton.Button, {
    id: "exportToJpeg",
    onClick: function onClick() {
      return exportAsImage('image/jpeg');
    }
  }, "Download JPEG image"), /*#__PURE__*/React.createElement(MenuButton.Button, {
    id: "exportToPdf",
    onClick: function onClick() {
      return exportAsImage('application/pdf');
    }
  }, "Download PDF document"), /*#__PURE__*/React.createElement(MenuButton.Button, {
    id: "exportToSvg",
    onClick: function onClick() {
      return exportAsImage('image/svg+xml');
    }
  }, "Download as SVG"));
}